import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import RtlLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "context/globalContext";
import { ROUTES } from "constants";
import { isValidJWT } from "helpers/isValidJWT";
import ResetPasswordPage from "components/resetPasswordPage/ResetPasswordPage";
import { decryptData } from "helpers";

const App = () => {
  const navigate = useNavigate();
  const { setUserDetails } = useGlobalContext();
  const location = useLocation();

  const { pathname } = location;

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (token && isValidJWT(token)) {
      try {
        const decodedToken = jwtDecode(decryptData(token));
        setUserDetails(decodedToken);
        if (!decodedToken?.id) {
          navigate("/auth/login");
          localStorage.removeItem("jwtToken");
        }
      } catch (error) {
        console.error("Invalid token", error);
      }
    } else {
      localStorage.removeItem("jwtToken");
      if (pathname.startsWith("/resetpassword")) return;
      navigate("/auth/login");
    }
  }, [navigate, setUserDetails, pathname]);

  return (
    <Routes>
      <Route path="/resetpassword/:id" element={<ResetPasswordPage />} />
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="admin/*" element={<AdminLayout />} />
      <Route path="rtl/*" element={<RtlLayout />} />
      <Route path="/" element={<Navigate to={ROUTES.admin} replace />} />
    </Routes>
  );
};

export default App;
